import React from 'react';
import * as Sentry from '@sentry/browser';
import { Button } from '@econ/ui-elements';
import Layout from '../../../shared/components/Layout';
import { EContext } from '../../../shared/components/EContext';
import error from '../error.png';
import '../style.css';

const language = navigator.language;

const translations = {
    da: {
        title: 'Der opstod en fejl',
        description: 'Undskyld, der gik noget galt',
        button: 'Genindlæs siden',
        report: 'Rapporter fejlen',
    },
    en: {
        title: 'An error occurred',
        description: "We're sorry - something went wrong.",
        button: 'Reload the page',
        report: 'Report the error',
    },
};

export default function UnexpectedError() {
    const { identity } = React.useContext(EContext);
    const texts = translations[language.slice(0, 2)] || translations.da;

    function sendSentryReport() {
        const eventId = Sentry.lastEventId();
        if (!!eventId) {
            Sentry.showReportDialog({
                eventId,
                user: {
                    name: (identity && identity.user.name) || '',
                    email: (identity && identity.user.email) || '',
                },
            });
        }
    }

    return (
        <Layout>
            <Layout.Content>
                <div id="error">
                    <img src={error} alt="An error occurred" />

                    <h1>{texts.title}</h1>
                    <p>{texts.description}</p>

                    <Button onClick={() => window.top.location.reload()} type="primary">
                        {texts.button}
                    </Button>

                    <br />

                    <Button onClick={sendSentryReport} type="discrete">
                        {texts.report}
                    </Button>
                </div>
            </Layout.Content>
        </Layout>
    );
}
